"use client"

const SettingsModal = ({ rangoSettings, setRangoSettings, slippage, setSlippage }) => {
  if (!rangoSettings) return null

  return (
    <div className={`rango-select-widget ${rangoSettings ? "show" : ""}`}>
      <div className="rango-selected-widget">
        <div className="rango-flex rango-flex--between">
          <div className="rango-icon" onClick={() => setRangoSettings(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m12 19l-7-7l7-7m7 7H5"
              />
            </svg>
          </div>
          <div className="rango-title">Settings</div>
          <div />
        </div>
        <div className="rango-setting-widget">
          <label>Slippage tolerance</label>
          <div className="rango-slippage-info">
            <p>
              The slippage tolerance is used to set the maximum acceptable difference between the expected price of a trade and the actual execution price. This protects you from executing trades at highly unfavorable prices, particularly in volatile or illiquid markets.
              <a href="https://share.google/3t2HoWjte0XjXBElo" target="_blank" rel="noopener noreferrer" className="slippage-link"> Learn more</a>
            </p>
          </div>
          <div className="rango-flex">
            {["0.5", "1", "3", "5", "8", "13"].map((value) => (
              <div key={value} className="rango-radio-label">
                <input
                  type="radio"
                  name="slippage"
                  value={value}
                  checked={slippage === value}
                  onChange={() => setSlippage(value)}
                />
                <span>{value}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SettingsModal
